const sendMoneyLink = (() => {
    let params;
    return {
        setParam: (url) => {
            if(!url) return
            params = url.split('?')[1]
        },
        getParam: () => {
            return params
        }
    }
})()